var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_25319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_25319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.675C12.7833 17.675 13.0208 17.5792 13.2125 17.3875C13.4042 17.1958 13.5 16.9583 13.5 16.675V13.475L14.4 14.375C14.5833 14.5583 14.8167 14.65 15.1 14.65C15.3833 14.65 15.6167 14.5583 15.8 14.375C15.9833 14.1917 16.075 13.9583 16.075 13.675C16.075 13.3917 15.9833 13.1583 15.8 12.975L13.2 10.4C13 10.2 12.7667 10.1 12.5 10.1C12.2333 10.1 12 10.2 11.8 10.4L9.2 12.975C9.01667 13.1583 8.925 13.3917 8.925 13.675C8.925 13.9583 9.01667 14.1917 9.2 14.375C9.38333 14.5583 9.61667 14.65 9.9 14.65C10.1833 14.65 10.4167 14.5583 10.6 14.375L11.5 13.475V16.675C11.5 16.9583 11.5958 17.1958 11.7875 17.3875C11.9792 17.5792 12.2167 17.675 12.5 17.675ZM5.5 21C4.95 21 4.47917 20.8042 4.0875 20.4125C3.69583 20.0208 3.5 19.55 3.5 19V6.525C3.5 6.29167 3.5375 6.06667 3.6125 5.85C3.6875 5.63333 3.8 5.43333 3.95 5.25L5.2 3.725C5.38333 3.49167 5.6125 3.3125 5.8875 3.1875C6.1625 3.0625 6.45 3 6.75 3H18.25C18.55 3 18.8375 3.0625 19.1125 3.1875C19.3875 3.3125 19.6167 3.49167 19.8 3.725L21.05 5.25C21.2 5.43333 21.3125 5.63333 21.3875 5.85C21.4625 6.06667 21.5 6.29167 21.5 6.525V19C21.5 19.55 21.3042 20.0208 20.9125 20.4125C20.5208 20.8042 20.05 21 19.5 21H5.5ZM5.9 6H19.1L18.25 5H6.75L5.9 6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnarchive);
export default __webpack_public_path__ + "static/media/icon_unarchive.215aace34059bc2dacc6cab387ee0f91.svg";
export { ForwardRef as ReactComponent };